import Element from "./element";
import DOMHelper from "../../lib/dom-helper";
import VideoModal from "./video-modal";

export default class SectionVideo extends Element {
	constructor(props = {}) {
		super(props);

		this.$container = null;
		this.$srcsetList = null;

		this.init();
	}

	init() {
		if (!this.$root || !this.$root.dataset || this.$root.dataset.video !== 'root') {
			throw new Error('Section Video: Root element is not defined.');
		}

		if (!this.$root.dataset.id) {
			throw new Error('Section Video: Root element must have data-id attribute.');
		}

		this.$container = this.$root.querySelector('[data-video="container"]');
		this.$srcsetList = this.$root.querySelectorAll('[data-video="srcset"]');

		this.setSource();
		this.initModalVideo();

		super.init();
	}

	setSource() {
		this.$srcsetList.forEach(($srcset) => {
			const src = $srcset.dataset.srcset;
			const media = $srcset.dataset.media;

			if (window.matchMedia(media).matches) {
				DOMHelper.createElement('source', {
					attributes: { src },
					$parent: this.$container
				});
			}

			$srcset.remove();
		});
	}

	initModalVideo() {
		new VideoModal({ id: this.$root.dataset.id });
	}
}